import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostBinding, HostListener, Inject, NgZone, OnDestroy, OnInit, Output, QueryList, ViewChild, ViewChildren, DOCUMENT } from '@angular/core';
import { FormBuilder, FormsModule } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AI_BOT_CONFIG, AlertPopup, config, HttpLoader } from 'app/app.config';
import { AssistBotService } from 'app/components/ai-assist/assist-bot.service';
import { HeaderService } from 'app/components/header/header.service';
import { ConfirmationDialogService } from 'app/confirmation-dialog/confirmation-dialog.service';
import { LlmService } from 'app/services/llm.service';
import { AiComponent } from '../ai/ai.component';
import { debounceTime, finalize, firstValueFrom, Observable, Subject, Subscription } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { AskQuestionService } from '../ask-question.service';
import { SharedModule } from 'app/shared/shared.module';
import { ELibraryService } from 'app/components/elibraryandcourse/e-library/e-library.service';
import { ChatService } from 'app/components/chat-list/chat.service';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { v4 as uuidv4 } from 'uuid';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { renderAsync } from 'docx-preview';
import { NgxDocViewerModule } from 'ngx-doc-viewer';

import {
  Room,
  RoomEvent,
  LocalAudioTrack,
  createLocalAudioTrack,
} from 'livekit-client';
import { ActivatedRoute, Router } from '@angular/router';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { VgBufferingModule } from '@videogular/ngx-videogular/buffering';

interface Transcript {
  id: string;
  text: string;
  isAgent: boolean;
  final: boolean;
}

interface TranscriptSegment {

  id: string;

  text: string;

  final: boolean;

}

declare const $: any;
declare const annyang: any;
declare var webkitSpeechRecognition: any;


interface SpeechRecognition extends EventTarget {
  lang: string;
  continuous: boolean;
  interimResults: boolean;
  start(): void;
  end(): void;
  onresult: ((event: SpeechRecognitionEvent) => void) | null;
  onError: ((event: any) => void) | null;
  onEnd: (() => void) | null;

}

interface SpeechRecognitionEvent extends Event {
  resultIndex: number;
  result: SpeechRecognitionResult;
}

export interface SourceParagraph {

  text: string;
  document_name?: string;
  page_number?: number;
  score?: number;
}

export type AvatarState = 'idle' | 'listening' | 'speaking';

export interface SaveHistoryPayload {

  conversation_id?: number | null;

  history_id?: number;

  sequence_id?: number;

  user_id: number | string;

  question: string;

  answer: string;

  question_type?: string;

  bot_type?: string;

  session_id?: string | null;

  query_type?: 'generic' | 'private' | string;

  source_doc?: string;

  document_ids?: number[] | string[];

  source_paragraphs?: SourceParagraph[];

  suggestions: string[],

  group_ids?: number[] | string[];


}



@Component({
  selector: 'app-ask-question',
  imports: [CommonModule, FormsModule, AiComponent, SharedModule, TooltipModule, DialogModule, PdfViewerModule, ProgressSpinnerModule, NgxDocViewerModule, VgControlsModule, VgCoreModule, VgOverlayPlayModule, VgBufferingModule],
  templateUrl: './ask-question.component.html',
  styleUrl: './ask-question.component.scss'
})
export class AskQuestionComponent implements OnInit, OnDestroy {

  @HostBinding('class.flex-grid') leftBarClass = true;
  @HostBinding('style.width') flexwidth = '100%';
  @HostBinding('style.flex-direction') direction = 'column';

  @ViewChild('chatContainer')
  chatContainer!: ElementRef<HTMLDivElement>;

  @ViewChild('autoCompleteInput')
  inputField!: ElementRef<HTMLInputElement>;

  @ViewChild('chatWrapper')
  chatWrapper!: ElementRef<HTMLDivElement>;

  @ViewChild('scrollContainer')
  scrollContainer!: ElementRef<HTMLDivElement>;

  @ViewChild('chatArea')
  chatArea!: ElementRef<HTMLDivElement>;

  @ViewChildren('aiComponent')
  aiComponents!: QueryList<AiComponent>;

  @ViewChild('dropdownWrapper')
  dropdownWrapper!: ElementRef;

  @ViewChild('docContainer') docContainer!: ElementRef;

  @ViewChild('messageInput')
  messageInput!: ElementRef<HTMLDivElement>;

  @ViewChild('userVideo')
  userVideo!: ElementRef<HTMLVideoElement>;

  @ViewChild('transcriptContainer')
  transcriptContainer!: ElementRef<HTMLDivElement>;

  @ViewChild('avatarPlayer', { static: false })
  avatarPlayer!: ElementRef<HTMLVideoElement>;

  @Output()
  historyCreated = new EventEmitter<any>();

  accessType: 'private' | 'generic' = 'private';
  toggle_text = 'Ask anything....';

  chatData: any[] = [];

  searchText: string = '';
  userMessage = '';

  stateCode = '';
  stateName = '';

  sessionId: any = '';

  private currentDocRequest = 0;

  messages: { type: 'user' | 'bot', text: string[] }[] = [];
  private scrollbarHeight: boolean = true;
  menuItem: MenuItem[] = [];
  isSidebarCollapsed = false;

  activeVoiceOver: boolean = false;
  queryInputValue = "";
  isRecording: boolean = false;
  autoSearchDafaultValue: string = "";
  voiceActiveSectionDisabled: boolean = false;
  voiceActiveSectionError: boolean = false;
  voiceActiveSectionSuccess: boolean = false;
  voiceActiveSectionListening: boolean = false;
  voiceText: any;
  viewBotHistoryList: boolean = false;
  showSearchSec: boolean = true;
  showPaginateSpinner = false;
  search: string = "";
  sortBy = 'time';
  listSortBy = 'updatedAt';
  is_tour_completed = false;
  totalRowCount: number = 0;
  activeUrl: any;
  selectedDoc_ids: any[] = [];

  isSelectFileType: any = '';

  showDocumentDropdown = false;
  showVoiceAgent: boolean = false;
  transcriptExpanded = false;

  agentStatus = 'Connecting...';

  electedDocuments: any[] = [];

  showDocumentPopup = false;
  documentLoading = false;
  aiLoading: boolean = false;
  isTyping: boolean = false;

  selectedDocumentUrl!: SafeResourceUrl;
  docViewHeading: any;
  selectedReadFile: any = "";
  fileType: any = "";

  searchDoc: string = '';

  filteredDocuments: any[] = [];


  isHistoryOpen = false;

  recognition!: SpeechRecognition;
  searchInList = new Subject<any>();
  destroy$ = new Subject<void>();
  isLoggedUserId: any;
  isSidebarOpen = false;

  isBotTitle: string = "";
  private headingSubscription!: Subscription;
  isExpanded = false;

  RECORD_LIMIT: number = config.DEFAULT_RECORD_LIMIT;
  OFFSET: number = config.DEFAULT_OFFSET;

  private BotURL = AI_BOT_CONFIG.agent.llmUrl;

  historyRecord: any[] = [];
  modalScrollThrottle = config.SCROLL_THROTTLE;
  modelScrollDistance = config.DEFAULT_SCROLL_DIST;
  viewControl = {
    changedSearchText: false
  };

  selectedItem: any = null;
  isMobileSidebarOpen = false;

  historyPanelOpen = false;

  activeHistoryId: number | null = null;

  historyList = [];

  filteredHistoryList = [...this.historyList];

  offset = config.DEFAULT_OFFSET;
  Record_limit = config.DEFAULT_RECORD_LIMIT;


  showPopup = false;
  isFullScreen = false;

  isConnected = false;

  isConnecting = false;

  isListening = false;

  message = '';

  placeholderMsg: string = '';


  private room!: Room;
  private localAudioTrack?: LocalAudioTrack;

  connected = false;
  connecting = false;

  muted = false;

  status = 'Ready';
  statusClass = '';


  transcriptList: any[] = [];
  TOKEN_ENDPOINT: any = '';

  companyName: string = '';
  jurisdiction: string = '';
  loggedUserName: any = '';

  showUserVideo: boolean = false;
  showVideoCall = false;

  videoMuted: boolean = true;

  private stream: MediaStream | null = null;


  showDocDropdown = false;


  selectedDocumentIndex = 0;

  documents = [
    {
      id: 1,
      name: 'Project Proposal.pdf',
      type: 'pdf'
    },
    {
      id: 2,
      name: 'Requirements.docx',
      type: 'doc'
    },
    {
      id: 3,
      name: 'Budget.xlsx',
      type: 'xls'
    },
    {
      id: 4,
      name: 'Notes.txt',
      type: 'txt'
    }
  ];

  selectedStateParam = '';

  selectedStateCodes: string[] = [];

  isAllStates = false;

  isLoggedUser: any;


  private isAtBottom = true;
  private scrollFrame: number | null = null;
  private shouldScroll = false;

  private historyScrollFrame: number | null = null;

  modelType = 4;

  selectedAllStateCode: any;


  stateNames: Record<string, string> = {
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    DC: 'District of Columbia',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    RI: 'Rhode Island',
    PR: 'Puerto Rico',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming'
  };


  agentState: 'idle' | 'listening' | 'speaking' = 'idle';
  avatarVideo = 'assets/images/ai_animate_avatar.mp4';

  avatarListening = false;
  avatarSpeaking = false;
  showAvatar = false;
  avatarMode = false;

  private remoteAudioElement?: HTMLAudioElement;

  avatarState: AvatarState = 'idle';


  constructor(
    private assistBotService: AssistBotService,
    private botService: AskQuestionService,
    private headerService: HeaderService,
    private confirmDialogService: ConfirmationDialogService,
    private fb: FormBuilder,
    private alert: AlertPopup,
    private httpLoader: HttpLoader,
    private sanitizer: DomSanitizer,
    private zone: NgZone,
    @Inject(DOCUMENT) private document: Document,
    private http: HttpClient,
    private llmService: LlmService,
    private documentService: ELibraryService,
    private chatService: ChatService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute

  ) {


    //Search filter history
    this.searchInList
      .pipe(debounceTime(500))
      .subscribe((event: any) => {

        this.search = (event.target.value ?? '').trim();
        this.OFFSET = 0;
        this.viewControl.changedSearchText = true;

        this.getBotHistory(0);
      });
  }


  ngOnInit(): void {

    this.headerService.getCurrentUserDetail().subscribe({
      next: (response: any) => {
        // console.log(userDetail, '-----------');

        const user = response.userDetail;
        this.isLoggedUser = user.first_name + ' ' + user.last_name;

      }
    })

    this.route.queryParamMap.subscribe(params => {

      const state = params.get('state') || '';

      if (state === 'all') {
        this.stateCode = '';
        this.stateName = '';

        this.placeholderMsg = `Ask questions about your policy for any state`
      } else {
        this.stateCode = params.get('state') || '';

        this.stateName =
          this.stateNames[this.stateCode] || this.stateCode;

        this.placeholderMsg = `Ask your policy-related questions about ${state}…`
      }

    });

    // Default query type
    this.accessType = 'private';

    this.assistBotService.queryType['library'] = true;

    const company_id = localStorage.getItem('company_id');

    const user_id = localStorage.getItem('user_id');

    const payload = {

      offset: this.offset,

      limit: 1000,

      search: this.search ?? '',

      company_id,

      user_id,

      is_doc_section: true

    };


    const stateCode = this.stateCode;
    const stateName = this.stateName;

    this.botService.getMessageAttachments(payload).subscribe({
      next: (res: any) => {
        const documents = res?.recordList ?? [];

        const code = stateCode?.trim().toLowerCase();
        const name = stateName?.trim().toLowerCase();

        if (this.stateCode === '') {
          this.selectedAllStateCode = [...new Set(
            documents
              .map((x: any) => x.policy_state)
              .filter((state: any) => state)
          )];
        }


        if (code != '' && name != '') {
          this.electedDocuments = documents.filter((doc: any) => {
            const message = doc?.policy_state?.trim().toLowerCase();

            return (
              (code && message?.includes(code)) ||
              (name && message?.includes(name))
            );
          });

          this.filteredDocuments = [...this.electedDocuments];
        } else {
          this.electedDocuments = documents;

          this.filteredDocuments = [...this.electedDocuments];
        }



        this.selectedDoc_ids = this.filteredDocuments.map(
          (item: any) => item.llmfile_uuid
        );

        // console.log(
        //   'Matched documents:',
        //   this.electedDocuments
        // );

        // console.log(
        //   'Selected IDs:',
        //   this.selectedDoc_ids
        // );
      },

      error: (err: any) => {
        console.error('Failed to load documents:', err);
        this.electedDocuments = [];
        this.selectedDoc_ids = [];
      }
    });

    // this.botService
    //   .getMessageAttachments(payload)
    //   .subscribe({

    //     next: (res: any) => {

    //       this.electedDocuments = res?.recordList ?? [];

    //       // Initialize filtered list
    //       this.filteredDocuments = [...this.electedDocuments];

    //       this.selectedDoc_ids = this.electedDocuments.map(
    //         (item: any) => item.llmfile_uuid
    //       );

    //     },

    //     error: (err: any) => {

    //       console.error('Failed to load documents', err);

    //       this.electedDocuments = [];
    //       this.filteredDocuments = [];
    //       this.selectedDoc_ids = [];

    //     }

    //   });

    this.getBotHistory(0);

    this.headerService.getCurrentUserDetail().subscribe((data: any) => {
      const user = data.userDetail;
      const company = data.company_details;

      this.loggedUserName = `${user.first_name} ${user.last_name}`;
      this.companyName = company.company_name;
      this.jurisdiction = user.work_state ?? 'CA';

      console.log(
        this.loggedUserName,
        this.companyName,
        this.jurisdiction
      );
    });


  }

  filterDocuments(): void {

    const keyword = this.searchDoc.trim().toLowerCase();

    if (!keyword) {
      this.filteredDocuments = [...this.electedDocuments];
      return;
    }

    this.filteredDocuments = this.electedDocuments.filter((doc: any) =>
      (doc.message || '').toLowerCase().includes(keyword)
    );

  }


  getBotHistory(pageNo: number): void {

    if (pageNo === 0) {
      this.OFFSET = 0;
      this.httpLoader.showLoader();
    }

    const userId = localStorage.getItem('user_id');

    if (!userId) {
      this.httpLoader.hideLoader();
      this.alert.showAlertMessage({
        message: 'User ID not found.'
      });
      return;
    }

    const payload = {
      offset: this.OFFSET,
      limit: 1000000,
      sort: this.sortBy,
      search: this.search?.trim() || '',
      user_id: userId
    };


    this.botService
      .getUserConversation(payload)
      .pipe(
        finalize(() => {
          this.showPaginateSpinner = false;
          this.httpLoader.hideLoader();
        })
      )
      .subscribe({
        next: (result: any) => {

          const records = (result?.data ?? []).sort(
            (a: any, b: any) =>
              new Date(b.updated_at || b.created_at).getTime() -
              new Date(a.updated_at || a.created_at).getTime()
          );

          if (pageNo === 0) {
            this.historyRecord = records;
          } else {
            this.historyRecord = [...this.historyRecord, ...records];
          }

          this.sessionId = records.length > 0
            ? records[0].session_id
            : null;

          this.chatData = [...this.historyRecord];
          this.totalRowCount = this.historyRecord.length;

          if (!this.selectedItem && this.historyRecord.length > 0) {
            this.onSelectConversation(this.historyRecord[0]);
          }
        },
        error: (err: any) => {
          console.error('Error fetching conversation history', err);

          this.alert.showAlertMessage(
            err?.error ?? {
              message: 'Failed to load conversation history.'
            }
          );
        }
      });
  }

  changeModelType(
    type: 'private' | 'generic'
  ): void {

    this.accessType = type;

    this.assistBotService.queryType['library'] =
      type === 'private';

    this.toggle_text =
      type === 'private'
        ? 'How may I assist you?'
        : 'Ask anything...';

  }


  changeQuery(event: Event): void {

    const target =
      event.target as HTMLInputElement;

    const type =
      target.value as
      'private' | 'generic';

    this.changeModelType(type);

  }


  onClickStartConversation(): void {

    localStorage.removeItem('session_id');

    this.chatData = [];

    this.selectedItem = null;

    this.activeHistoryId = null;

    this.queryInputValue = '';

    this.aiLoading = false;

    this.isTyping = false;

    this.toggle_text =
      this.accessType === 'private'
        ? 'How may I assist you?'
        : 'Ask anything...';

    this.botService.stopListening();
    this.botService.stopSpeaking();

    requestAnimationFrame(() => {
      const container = this.chatContainer?.nativeElement;

      if (container) {
        container.scrollTop = 0;
      }

      this.inputField?.nativeElement?.focus();
    });

    this.llmService.llmGenerateSessionId().subscribe((res: any) => {
      this.sessionId = res.session_id;
    })

  }


  toggleHistory(): void {

    this.isHistoryOpen =
      !this.isHistoryOpen;

  }


  deleteItem(item: any): void {

    if (!item) {

      return;

    }

    this.historyList = this.historyList.filter(

      (history: any) =>

        history.conversation_id !==

        item.conversation_id

    );

  }


  togglePin(item: any): void {

    if (!item) {

      return;

    }

    item.pinned = !item.pinned;

    // Move pinned items to top
    this.historyList.sort(

      (a: any, b: any) => {

        // Pinned first
        if (a.pinned !== b.pinned) {

          return a.pinned ? -1 : 1;

        }

        // Sort by updated_at or created_at (latest first)

        const aDate = new Date(

          a.updated_at ?? a.created_at

        ).getTime();

        const bDate = new Date(

          b.updated_at ?? b.created_at

        ).getTime();

        return bDate - aDate;

      }

    );

  }


  selectHistory(

    conversation: any

  ): void {

    if (!conversation) {

      return;

    }

    this.selectedItem = conversation;

    this.onSelectConversation(

      conversation

    );

  }


  autoResize(

    event: Event

  ): void {

    const textarea =

      event.target as HTMLTextAreaElement;

    if (!textarea) {

      return;

    }

    // Reset height to calculate correctly

    textarea.style.height = 'auto';

    const maxHeight = 180;

    const newHeight = Math.min(

      textarea.scrollHeight,

      maxHeight

    );

    textarea.style.height =

      `${newHeight}px`;

    // Enable scrollbar when max height reached

    textarea.style.overflowY =

      textarea.scrollHeight > maxHeight

        ? 'auto'

        : 'hidden';

  }


  onEnter(

    event: KeyboardEvent

  ): void {

    // Allow Shift + Enter for new line

    if (

      event.key === 'Enter' &&

      !event.shiftKey

    ) {

      event.preventDefault();

      const question =

        this.queryInputValue?.trim();

      if (!question) {

        return;

      }

      this.submitQuestion();

    }

  }

  onScroll(): void {
    const container = this.chatContainer?.nativeElement;

    if (!container) {
      return;
    }

    const threshold = 120;

    const distanceFromBottom =
      container.scrollHeight -
      container.scrollTop -
      container.clientHeight;

    this.isAtBottom = distanceFromBottom <= threshold;
  }


  // ngAfterViewChecked(): void {

  //   // Scroll only when required

  //   if (

  //     this.isAtBottom &&

  //     this.shouldScroll

  //   ) {

  //     this.scrollToBottom(false);

  //     this.shouldScroll = false;

  //   }

  // }



  openMenu(item: any): void {

    if (!item) {

      return;

    }

    this.menuItem = [

      {

        label: 'View',

        icon: 'pi pi-eye',

        command: () => {

          this.selectHistory(item);

        }

      },

      {

        label: 'Edit',

        icon: 'pi pi-pencil',

        command: () => {

          this.editConversation(item);

        }

      },

      {

        label: 'Delete',

        icon: 'pi pi-trash',

        command: () => {

          this.deleteConversation(item);

        }

      }

    ];

  }

  editConversation(item: any): void {

    if (!item) {

      return;

    }

    const currentTitle =

      item.title ??

      item.question ??

      '';

    const updatedTitle = prompt(

      'Edit conversation title',

      currentTitle

    );

    if (

      updatedTitle === null ||

      updatedTitle.trim() === '' ||

      updatedTitle === currentTitle

    ) {

      return;

    }

    const payload = {

      title: updatedTitle.trim()

    };

    this.httpLoader.showLoader();

    // this.botService

    //   .updateConversation(

    //     item.conversation_id,

    //     payload

    //   )

    //   .subscribe({

    //     next: (res: any) => {

    //       item.title =

    //         updatedTitle.trim();

    //       this.alert.showAlertMessage({

    //         message:

    //           'Conversation updated successfully.'

    //       });

    //       this.httpLoader.hideLoader();

    //     },

    //     error: (err: any) => {

    //       console.error(

    //         'Update failed',

    //         err

    //       );

    //       this.alert.showAlertMessage({

    //         message:

    //           'Failed to update conversation.'

    //       });

    //       this.httpLoader.hideLoader();

    //     }

    //   });

  }

  deleteConversation(item: any): void {

    if (!item?.conversation_id) {

      return;

    }

    // this.confirmDialogService.confirm({

    //   message:

    //     'Are you sure you want to delete this conversation?',

    //   header: 'Delete Conversation',

    //   icon: 'pi pi-exclamation-triangle',

    //   accept: () => {

    //     this.httpLoader.showLoader();

    //     this.botService

    //       .deleteConversation(

    //         item.conversation_id

    //       )

    //       .subscribe({

    //         next: (res: any) => {

    //           this.httpLoader.hideLoader();

    //           if (!res?.success) {

    //             this.alert.showAlertMessage({

    //               message:

    //                 'Failed to delete conversation.'

    //             });

    //             return;

    //           }

    //           // Remove from history list

    //           this.historyRecord =

    //             this.historyRecord.filter(

    //               (history: any) =>

    //                 history.conversation_id !==

    //                 item.conversation_id

    //             );

    //           // Remove from chat list

    //           this.chatData =

    //             this.chatData.filter(

    //               (chat: any) =>

    //                 chat.conversation_id !==

    //                 item.conversation_id

    //             );

    //           // Clear selected conversation

    //           if (

    //             this.selectedItem

    //               ?.conversation_id ===

    //             item.conversation_id

    //           ) {

    //             this.selectedItem = null;

    //             this.activeHistoryId = null;

    //           }

    //           this.alert.showAlertMessage({

    //             message:

    //               'Conversation deleted successfully.'

    //           });

    //         },

    //         error: (err: any) => {

    //           console.error(

    //             'Delete conversation failed',

    //             err

    //           );

    //           this.httpLoader.hideLoader();

    //           this.alert.showAlertMessage(

    //             err?.error ?? {

    //               message:

    //                 'Unable to delete conversation.'

    //             }

    //           );

    //         }

    //       });

    //   }

    // });

  }

  showSearchbox(toggle?: boolean): void {

    // Toggle or set explicitly
    this.showSearchSec =

      toggle !== undefined

        ? toggle

        : !this.showSearchSec;

    // Reset search if user had searched earlier

    if (this.viewControl.changedSearchText) {

      this.search = '';

      this.viewControl.changedSearchText = false;

      this.OFFSET = 0;

      this.historyRecord = [];

      this.chatData = [];

      this.getBotHistory(0);

    }

  }
  openMobileSidebar() {
    this.isMobileSidebarOpen = true;
  }

  closeMobileSidebar() {
    this.isMobileSidebarOpen = false;
  }

  closeSidebar() {
    this.isSidebarOpen = false;
  }

  openSidebar() {
    this.isSidebarOpen = true;
  }

  toggleHistoryList() {
    this.isExpanded = !this.isExpanded;
  }

  onClickHomePage() {
    this.botService.stopListening();
    this.botService.stopSpeaking();
  }

  onKeyPressEvent(event: KeyboardEvent) {

    if (event.key === 'Enter') {
      this.submitQuestion();
    }
  }

  trackByFn(

    index: number,

    item: any

  ): number {

    return (

      item.history_id ||

      item.conversation_id ||

      index

    );

  }

  onSelectConversation(conversation: any): void {
    if (!conversation) {
      this.selectedItem = null;
      this.activeHistoryId = null;
      this.chatData = [];
      return;
    }

    const histories = Array.isArray(conversation.histories)
      ? [...conversation.histories]
      : [];

    this.selectedItem = {
      ...conversation,
      histories
    };

    this.chatData = histories;

    const lastMessage =
      histories.length > 0
        ? histories[histories.length - 1]
        : null;

    this.activeHistoryId =
      lastMessage?.history_id ?? null;

    this.aiLoading = false;
    this.isTyping = false;
    this.queryInputValue = '';

    this.cdr.detectChanges();

    // History load = smooth ChatGPT-style scroll
    this.scrollHistoryToBottom();
  }

  loadConversation(
    conversationId: number
  ): void {

    const conversation =

      this.chatData.find(

        (item: any) =>

          item.conversation_id ===

          conversationId

      );

    if (!conversation) {

      this.selectedItem = null;

      this.activeHistoryId = null;

      return;

    }

    this.onSelectConversation(
      conversation
    );

  }

  onScrollUp(
    event?: Event
  ): void {

    const listLength =

      this.chatData.length;

    const hasMore =

      this.totalRowCount >

      listLength;

    if (

      hasMore &&

      !this.showPaginateSpinner

    ) {

      this.showPaginateSpinner = true;

      this.OFFSET++;

      this.getBotHistory(
        this.OFFSET
      );

    }

  }

  startVoiceRecognition(): void {

    if (!annyang) {
      console.warn('Speech recognition is not supported.');
      return;
    }

    this.activeVoiceOver = true;

    this.inputField?.nativeElement?.classList.add('listening');
    this.inputField?.nativeElement?.setAttribute(
      'placeholder',
      'Listening...'
    );

    // Reset
    annyang.abort();
    annyang.removeCommands();
    annyang.removeCallback();

    let previousText = '';

    annyang.addCallback('result', (phrases: string[]) => {

      this.zone.run(() => {

        if (!phrases?.length) {
          return;
        }

        const current = phrases[0].trim();

        if (!current) {
          return;
        }

        // Prevent duplicate appending
        if (current === previousText) {
          return;
        }

        previousText = current;

        this.queryInputValue = current;

        this.messageInput.nativeElement.innerText = this.queryInputValue;

        this.activeVoiceOver = false;
      });

    });

    annyang.addCallback('end', () => {

      this.zone.run(() => {

        this.activeVoiceOver = false;

        this.inputField?.nativeElement?.classList.remove('listening');

        this.inputField?.nativeElement?.setAttribute(
          'placeholder',
          'Ask anything...'
        );

      });

    });

    annyang.addCallback('error', (error: any) => {

      console.error(error);

      this.zone.run(() => {

        this.activeVoiceOver = false;

        this.inputField?.nativeElement?.classList.remove('listening');

      });

    });

    annyang.start({
      autoRestart: false,
      continuous: true
    });

  }


  stopVoiceRecord(): void {

    if (annyang) {

      annyang.abort();

      annyang.removeCommands();

      annyang.removeCallback('end');

      annyang.removeCallback('error');

    }

    this.activeVoiceOver = false;

    this.inputField
      ?.nativeElement
      ?.classList
      .remove('listening');

    this.inputField
      ?.nativeElement
      ?.setAttribute(
        'placeholder',
        'Ask anything...'
      );

  }

  submitVoiceRecord(): void {

    this.stopVoiceRecord();

    const question =

      this.queryInputValue?.trim();

    if (!question) {

      return;

    }

    this.submitQuestion();

  }

  // submitQuestion(): void {

  //   const question =

  //     this.queryInputValue?.trim();

  //   if (!question) {

  //     return;

  //   }

  //   const message = {

  //     history_id: null,

  //     conversation_id:

  //       this.selectedItem
  //         ?.conversation_id ?? null,

  //     question,

  //     answer: '',

  //     query_type: '',

  //     search: true,

  //     source_doc: '',

  //     source_paragraphs: [],

  //     created_at:

  //       new Date(),

  //     isTyping: true

  //   };



  //   if (!this.selectedItem) {

  //     this.selectedItem = {

  //       conversation_id: null,

  //       histories: []

  //     };

  //   }

  //   this.selectedItem = {

  //     ...this.selectedItem,

  //     histories: [

  //       ...(this.selectedItem
  //         .histories ?? []),

  //       message

  //     ]

  //   };

  //   this.chatData = this.selectedItem.histories;

  //   this.messageInput.nativeElement.innerHTML = '';
  //   this.queryInputValue = '';

  //   this.shouldScroll = true;

  //   setTimeout(() => {

  //     this.scrollToBottom();

  //   }, 0);

  //   if (

  //     this.accessType ===

  //     'private'

  //   ) {

  //     this.handlePrivateQuery(

  //       message

  //     );

  //   }

  //   else {

  //     this.handleGenericQuery(

  //       message

  //     );

  //   }

  // }

  submitQuestion(selectedQuestion?: string): void {

    const question =
      selectedQuestion?.trim() ||
      this.queryInputValue?.trim();

    if (!question) {
      return;
    }

    const message: any = {

      history_id: null,

      conversation_id:
        this.selectedItem?.conversation_id ?? null,

      question,

      answer: '',

      query_type: '',

      search: true,

      source_doc: '',

      source_paragraphs: [],

      document_ids: [],

      suggestions: [],

      showSuggestions: false,

      created_at: new Date(),

      isTyping: true
    };

    if (!this.selectedItem) {

      this.selectedItem = {
        conversation_id: null,
        histories: []
      };
    }

    this.selectedItem = {

      ...this.selectedItem,

      histories: [
        ...(this.selectedItem.histories ?? []),
        message
      ]
    };

    this.chatData =
      this.selectedItem.histories;

    // Clear input only for manually typed question
    if (!selectedQuestion) {

      this.messageInput.nativeElement.innerHTML = '';

      this.queryInputValue = '';
    }

    this.cdr.detectChanges();

    this.isAtBottom = true;

    this.scrollToBottom();

    if (this.accessType === 'private') {

      this.handlePrivateQuery(message);

    } else {

      this.handleGenericQuery(message);
    }
  }

  handleGenericQuery(message: any): void {

    let sessionId: any =
      this.sessionId || localStorage.getItem('session_id');

    let payload: any;
    let request$: Observable<any>;

    payload = {
      session_id: sessionId,
      message: message.question
    };

    request$ = this.llmService.benfitGenericStreaming(payload)

    this.handleQuery(
      message,
      request$,
      'generic'
    );

  }

  handlePrivateQuery(message: any): void {

    let sessionId: any =
      this.sessionId || localStorage.getItem('session_id');

    let payload: any;
    let request$: Observable<any>;

    switch (Number(this.modelType)) {

      // =====================================================
      // MODEL TYPE 1
      // =====================================================
      case 1:
        payload = {
          session_id: sessionId,
          query: message.question,
          doc_id: this.selectedDoc_ids,
          name: this.loggedUserName,
          jurisdiction: this.jurisdiction,
          company_name: this.companyName
        };

        request$ = this.llmService.streamPrivateQuery(payload);
        break;

      // =====================================================
      // MODEL TYPE 2
      // =====================================================
      case 2:
        payload = {
          session_id: sessionId,
          query: message.question,
          doc_id: this.selectedDoc_ids,
          name: this.loggedUserName,
          jurisdiction: this.jurisdiction,
          company_name: this.companyName
        };

        request$ = this.llmService.streamPrivateQuery(payload);
        break;

      // =====================================================
      // MODEL TYPE 3
      // =====================================================
      case 3:
        payload = {
          session_id: sessionId,
          query: message.question,
          doc_id: this.selectedDoc_ids,
          name: this.loggedUserName,
          jurisdiction: this.jurisdiction,
          company_name: this.companyName
        };

        request$ = this.llmService.streamPrivateQuery(payload);
        break;

      // =====================================================
      // MODEL TYPE 4
      // =====================================================
      case 4:
        payload = {
          session_id: sessionId,
          message: message.question,
          region: this.stateCode || this.selectedAllStateCode,
          document_id: this.selectedDoc_ids,
        };

        request$ = this.llmService.streamPrivateQuery1(payload);
        break;

      // =====================================================
      // INVALID MODEL TYPE
      // =====================================================
      default:
        console.error('Invalid model type:', this.modelType);
        return;
    }

    // =====================================================
    // COMMON SSE HANDLER
    // =====================================================
    this.handleQuery(
      message,
      request$,
      'private'
    );
  }


  askAgain(event: any): void {

    if (!event || this.aiLoading) {
      return;
    }

    const question =
      typeof event === 'string'
        ? event.trim()
        : event?.suggestion?.trim();

    if (!question) {
      return;
    }

    console.log(
      'Submitting suggestion:',
      question
    );

    this.submitQuestion(question);
  }

  private handleQuery(
    message: any,
    request$: Observable<any>,
    queryType: 'generic' | 'private'
  ): void {

    console.log(queryType, 'queryType');

    // =====================================================
    // INITIAL STATE
    // =====================================================

    message.answer = '';
    message.isTyping = true;
    message.query_type = queryType;

    message.source_doc = '';
    message.source_paragraphs = [];
    message.document_ids = [];

    message.suggestions = [];
    message.showSuggestions = false;

    message.stage = '';
    message.stageTime = 0;
    message.search_method = '';
    message.total_sources = 0;

    this.aiLoading = true;

    request$.subscribe({

      // ===================================================
      // SSE NEXT EVENT
      // ===================================================

      next: (event: any) => {

        if (!event?.event) {
          return;
        }

        switch (event?.event) {

          // ===============================================
          // STAGE
          // ===============================================

          case 'stage': {

            message.stage =
              event.data?.name ?? '';

            message.stageTime =
              Number(event.data?.ms ?? 0);

            break;
          }


          // ===============================================
          // META
          // ===============================================

          case 'meta': {

            message.search_method =
              event.data?.search_method ?? '';

            message.total_sources =
              Number(event.data?.total_sources ?? 0);

            break;
          }


          // ===============================================
          // TOKEN
          // ===============================================

          case 'token': {

            message.isTyping = false;

            const chunk =
              typeof event.data?.text === 'string'
                ? event.data.text
                : typeof event.data?.html === 'string'
                  ? event.data.html
                  : '';

            if (chunk) {

              const normalizedChunk = chunk
                .replace(/\r\n/g, '\n')
                .replace(/\\r\\n/g, '\n')
                .replace(/\\n/g, '\n');

              message.answer =
                (message.answer || '') + normalizedChunk;

              this.shouldScroll = true;

              // Do not force scroll for every SSE token
              // this.scrollToBottom();
            }

            break;
          }


          // ===============================================
          // TOOL
          // ===============================================

          case 'tool': {

            message.isTyping = false;

            const result =
              event.data ?? {};



            message.tool_result = result

            break;
          }

          // ===============================================
          // SOURCES
          // ===============================================

          case 'sources': {

            message.isTyping = false;

            const result =
              event.data ?? {};

            const sources =
              Array.isArray(result.sources)
                ? result.sources
                : [];

            console.log(
              'SSE Sources:',
              sources
            );

            this.setMessageSources(
              message,
              sources
            );

            break;
          }


          case 'state': {

            message.isTyping = false;

            const result =
              event.data ?? {};

            const source_file = Array.isArray(result?.source_file)
              ? result.source_file
              : result?.source_file
                ? [result.source_file]
                : [];


            message.source_doc = source_file;

            // this.setMessageSources(
            //   message,
            //   source_file
            // )

            break;
          }

          // ===============================================
          // SUGGESTIONS
          // ===============================================

          case 'suggest': {

            message.isTyping = false;

            const result =
              event.data ?? {};

            console.log(
              'SSE suggest event:',
              result
            );

            // Support:
            // { options: [...] }
            // { suggestions: [...] }
            // { data: { options: [...] } }

            const options =
              Array.isArray(result.options)
                ? result.options
                : Array.isArray(result.suggestions)
                  ? result.suggestions
                  : [];

            const suggestions =
              options
                .filter(
                  (option: unknown): option is string =>
                    typeof option === 'string' &&
                    option.trim().length > 0
                )
                .map(
                  (option: string) =>
                    option.trim()
                )
                .slice(0, 3);

            console.log(
              'Parsed suggestions:',
              suggestions
            );

            if (suggestions.length > 0) {

              message.suggestions =
                suggestions;

              message.showSuggestions =
                true;
            }

            console.log(
              'Final suggestions:',
              message.suggestions
            );

            console.log(
              'Show suggestions:',
              message.showSuggestions
            );

            break;
          }


          // ===============================================
          // DONE
          // ===============================================

          case 'done': {

            this.aiLoading = false;
            message.isTyping = false;

            const result =
              event.data ?? {};

            console.log(
              'SSE done event:',
              result
            );

            // =============================================
            // FINAL ANSWER
            // =============================================

            if (
              typeof result.answer === 'string' &&
              result.answer.trim().length > 0
            ) {
              message.answer =
                result.answer;
            }


            // =============================================
            // CREATED AT
            // =============================================

            message.created_at =
              result.created_at ?? new Date();


            // =============================================
            // PRIVATE SOURCES
            // =============================================

            if (
              queryType === 'private' &&
              Array.isArray(result.source_paragraphs)
            ) {

              this.setMessageSources(
                message,
                result.source_paragraphs
              );
            }

            let finalSuggestions: any = '';

            if (Array.isArray(result.suggestions)) {

              finalSuggestions = result.suggestions
                .filter(
                  (question: unknown): question is string =>
                    typeof question === 'string' &&
                    question.trim().length > 0
                )
                .map(
                  (question: string) =>
                    question.trim()
                )
                .slice(0, 3);

              if (finalSuggestions.length > 0) {
                message.suggestions = [...finalSuggestions];
              }
            }

            console.log(finalSuggestions, '::::::::::::finalSuggestions:::::::::::::');


            // =============================================
            // FINAL UI STATE
            // =============================================

            message.suggestions = Array.isArray(message.suggestions)
              ? [...message.suggestions]
              : [];

            console.log(message.suggestion, ':::::::::::message.suggestion::::::::::::::');


            message.showSuggestions =
              message.suggestions.length > 0;


            // =============================================
            // SAVE HISTORY
            // =============================================

            const saveOptions = {

              query_type:
                queryType,

              document_ids:
                Array.isArray(message.document_ids)
                  ? message.document_ids
                  : [],

              source_doc:
                typeof message.source_doc === 'string'
                  ? message.source_doc
                  : '',

              source_paragraphs:
                Array.isArray(message.source_paragraphs)
                  ? message.source_paragraphs
                  : [],

              suggestions:
                [...message.suggestions]
            };

            console.log(
              'Final saveOptions:',
              saveOptions
            );

            this.saveBotHistory(
              message,
              saveOptions
            );


            // =============================================
            // SCROLL
            // =============================================

            this.shouldScroll = true;

            this.scrollToBottom();

            break;
          }


          // ===============================================
          // SSE ERROR EVENT
          // ===============================================

          case 'error': {

            this.aiLoading = false;
            message.isTyping = false;

            message.suggestions = [];
            message.showSuggestions = false;

            message.answer =
              event.data?.error ??
              event.data?.message ??
              'Something went wrong.';

            this.scrollToBottom();

            break;
          }


          // ===============================================
          // UNKNOWN EVENT
          // ===============================================

          default: {

            console.warn(
              'Unknown SSE Event:',
              event
            );

            break;
          }
        }
      },


      // ===================================================
      // OBSERVABLE ERROR
      // ===================================================

      error: (err: any) => {

        console.error(
          'AI request error:',
          err
        );

        this.aiLoading = false;
        message.isTyping = false;

        message.suggestions = [];
        message.showSuggestions = false;

        message.answer =
          err?.error?.message ??
          err?.message ??
          'Something went wrong. Please try again.';

        this.shouldScroll = true;

        this.scrollToBottom();
      },


      // ===================================================
      // COMPLETE
      // ===================================================

      complete: () => {

        this.aiLoading = false;
        message.isTyping = false;

        this.shouldScroll = true;

        this.scrollToBottom();
      }
    });
  }

  private setMessageSources(
    message: any,
    sources: any[]
  ): void {

    if (!Array.isArray(sources)) {

      message.source_paragraphs = [];
      message.source_doc = '';
      message.document_ids = [];
      message.total_sources = 0;

      return;
    }

    message.source_paragraphs = sources;

    // const documentNames =
    //   this.getUniqueDocumentNames(sources);

    // message.source_doc =
    //   documentNames.join(', ');

    // message.source_doc = source_file;

    message.document_ids =
      this.getUniqueDocIds(sources);

    message.total_sources =
      sources.length;
  }

  // =====================================================
  // UNIQUE DOCUMENT NAMES
  // =====================================================

  private getUniqueDocumentNames(
    sources: any[]
  ): string[] {

    if (!Array.isArray(sources)) {
      return [];
    }

    return Array.from(
      new Set(
        sources
          .map(source => source?.filename)
          .filter(
            (filename): filename is string =>
              typeof filename === 'string' &&
              filename.trim().length > 0
          )
          .map(filename => filename.trim())
      )
    );
  }


  // =====================================================
  // UNIQUE DOCUMENT IDS
  // =====================================================

  private getUniqueDocIds(
    sources: any[]
  ): string[] {

    if (!Array.isArray(sources)) {
      return [];
    }

    return Array.from(
      new Set(
        sources
          .map(source => source?.document_id)
          .filter(
            (id): id is string =>
              typeof id === 'string' &&
              id.trim().length > 0
          )
          .map(id => id.trim())
      )
    );
  }

  saveBotHistory(
    message: any,
    options?: {
      query_type?: 'generic' | 'private';
      document_ids?: string[];
      source_doc?: string;
      source_paragraphs?: any[];
      suggestions?: any[]
    }
  ): void {

    console.time('saveBotHistory');

    const userId = localStorage.getItem('user_id');

    if (!userId) {
      console.error('User ID not found.');
      return;
    }

    let sessionId = localStorage.getItem('session_id');

    if (!sessionId) {
      sessionId = uuidv4();
      localStorage.setItem('session_id', sessionId);
    }

    const payload: SaveHistoryPayload = {

      conversation_id:
        message?.conversation_id ??
        this.selectedItem?.conversation_id ??
        null,

      user_id: userId,

      question:
        message?.question?.trim() ?? '',

      answer:
        message?.answer ?? '',

      question_type: 'history',

      bot_type: 'bot',

      session_id: sessionId,

      query_type:
        options?.query_type ?? 'generic',

      source_doc:
        options?.source_doc ??
        message?.source_doc ??
        '',

      document_ids:
        options?.document_ids ?? [],

      source_paragraphs:
        (options?.source_paragraphs ?? [])
          .map((item: any) =>
            typeof item === 'string'
              ? item.trim()
              : item?.text?.trim() ?? ''
          )
          .filter(Boolean),

      suggestions:
        (options?.suggestions ?? [])
          .map((item: any) =>
            typeof item === 'string'
              ? item.trim()
              : typeof item?.text === 'string'
                ? item.text.trim()
                : ''
          )
          .filter(Boolean)
          .slice(0, 3)
    };

    console.time('API');

    this.botService.createConversation(payload).subscribe({

      next: (res: any) => {

        console.timeEnd('API');

        if (!res?.success) {
          return;
        }

        const data = res.data;

        Object.assign(message, {

          conversation_id: data.conversation_id,

          history_id: data.history_id,

          sequence_id: data.sequence_id,

          created_at: data.created_at ?? new Date(),

          updated_at: data.updated_at ?? new Date(),

          search: false

        });

        // Update selected conversation
        if (this.selectedItem) {

          this.selectedItem = {

            ...this.selectedItem,

            conversation_id: data.conversation_id,

            histories: [...(this.selectedItem.histories ?? [])]

          };

        }

        const index = this.historyRecord.findIndex(
          (item: any) =>
            item.conversation_id === data.conversation_id
        );

        if (index > -1) {

          const conversation = this.historyRecord[index];

          conversation.updated_at =
            data.updated_at ?? new Date();

          conversation.histories =
            this.selectedItem?.histories ?? [message];

          // Remove from current position
          this.historyRecord.splice(index, 1);

          // Preserve pinned ordering
          if (conversation.is_pinned) {

            this.historyRecord.unshift(conversation);

          } else {

            const firstUnPinned = this.historyRecord.findIndex(
              (x: any) => !x.is_pinned
            );

            if (firstUnPinned === -1) {
              this.historyRecord.push(conversation);
            } else {
              this.historyRecord.splice(
                firstUnPinned,
                0,
                conversation
              );
            }
          }

        } else {

          const newConversation = {

            conversation_id: data.conversation_id,

            question: data.question,

            histories: this.selectedItem?.histories ?? [message],

            created_at: data.created_at ?? new Date(),

            updated_at: data.updated_at ?? new Date(),

            is_pinned: false

          };

          console.log(newConversation, '------------history---------');


          const firstUnPinned = this.historyRecord.findIndex(
            (x: any) => !x.is_pinned
          );

          if (firstUnPinned === -1) {
            this.historyRecord.push(newConversation);
          } else {
            this.historyRecord.splice(
              firstUnPinned,
              0,
              newConversation
            );
          }

        }

        // Refresh current chat only
        this.chatData =
          this.selectedItem?.histories ?? [];

        this.historyCreated.emit(data);

        console.timeEnd('saveBotHistory');

      },

      error: (err: any) => {

        console.timeEnd('API');
        console.timeEnd('saveBotHistory');

        console.error('Save history failed:', err);

        this.alert.showAlertMessage({

          message:
            err?.error?.message ??
            'Failed to save conversation.'

        });

      }

    });

  }



  private scrollToBottomInstant(): void {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const container = this.chatContainer?.nativeElement;

        if (!container) {
          return;
        }

        container.scrollTop =
          container.scrollHeight - container.clientHeight;

        this.isAtBottom = true;
      });
    });
  }

  private scrollToBottom(force = false): void {
    const container = this.chatContainer?.nativeElement;

    if (!container) {
      return;
    }

    // User manually scrolled up.
    if (!force && !this.isAtBottom) {
      return;
    }

    if (this.scrollFrame !== null) {
      cancelAnimationFrame(this.scrollFrame);
    }

    this.scrollFrame = requestAnimationFrame(() => {
      this.scrollFrame = null;

      const element = this.chatContainer?.nativeElement;

      if (!element) {
        return;
      }

      element.scrollTop =
        element.scrollHeight - element.clientHeight;

      this.isAtBottom = true;
    });
  }

  private scrollAfterResponseRendered(): void {
    if (!this.isAtBottom) {
      return;
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {

        setTimeout(() => {

          const container = this.chatContainer?.nativeElement;

          if (!container) {
            return;
          }

          container.scrollTop =
            container.scrollHeight - container.clientHeight;

          this.isAtBottom = true;
          this.shouldScroll = false;

        }, 20);

      });
    });
  }


  onScrollDown(): void {

    const currentCount =

      this.historyRecord.length;

    const hasMore =

      this.totalRowCount >

      currentCount;

    if (

      hasMore &&

      !this.showPaginateSpinner

    ) {

      this.OFFSET++;

      this.showPaginateSpinner = true;

      this.getBotHistory(
        this.OFFSET
      );

    }

  }

  onClickDropdownDocumentList(
    event: MouseEvent
  ): void {

    event.stopPropagation();

    this.showDocumentDropdown =

      !this.showDocumentDropdown;

  }


  filterHistory(): void {

    const search =

      this.searchText

        ?.toLowerCase()

        ?.trim() ?? '';

    if (!search) {

      this.filteredHistoryList = [

        ...this.historyList

      ];

      return;

    }

    this.filteredHistoryList =

      this.historyList.filter(

        (item: any) => {

          const question =

            item?.question

              ?.toLowerCase()

            ?? '';

          const answer =

            item?.answer

              ?.toLowerCase()

            ?? '';

          return (

            question.includes(

              search

            )

            ||

            answer.includes(

              search

            )

          );

        }

      );

  }

  onHistoryClick(item: any): void {
    if (!item) {
      return;
    }

    this.selectedItem = item;
    this.activeHistoryId = item.sequence_id;
    this.isHistoryOpen = false;

    // Store session for future requests
    if (item.session_id) {
      localStorage.setItem('session_id', item.session_id);
    }

    // If conversation is not loaded, load it first
    if (!this.chatData || this.chatData.length === 0) {
      this.getBotHistory(0); // or this.getUserConversation(item.session_id)
      return;
    }

    this.scrollToHistoryItem(item);
  }

  private scrollToHistoryItem(item: any): void {
    this.cdr.detectChanges();

    setTimeout(() => {
      const child = this.aiComponents?.find(
        component => component.data?.sequence_id === item.sequence_id
      );

      if (!child) {
        return;
      }

      child.contentDiv?.nativeElement?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest'
      });

      child.focusContent();
    }, 200);
  }

  get pinnedHistory(): any[] {

    return this.historyRecord?.filter(

      (item: any) => item?.is_pinned

    ) ?? [];

  }


  get recentHistory(): any[] {

    return this.historyRecord?.filter(

      (item: any) => !item?.is_pinned

    ) ?? [];

  }

  pinItem(item: any): void {

    if (!item?.conversation_id) {

      return;

    }

    const conversationId =

      item.conversation_id;

    const isPinned =

      !item.is_pinned;

    const payload = {

      is_pinned: isPinned

    };

    this.httpLoader.showLoader();

    this.botService

      .setPinConversationSelected(

        conversationId,

        payload

      )

      .subscribe({

        next: (result: any) => {

          this.httpLoader.hideLoader();

          if (!result?.success) {

            return;

          }

          // Update local item

          item.is_pinned = isPinned;

          // Re-sort history

          this.historyRecord.sort(

            (a: any, b: any) => {

              // Pinned items first

              if (

                a.is_pinned !==

                b.is_pinned

              ) {

                return a.is_pinned

                  ? -1

                  : 1;

              }

              // Latest updated first

              const aDate =

                new Date(

                  a.updated_at ??

                  a.created_at

                ).getTime();

              const bDate =

                new Date(

                  b.updated_at ??

                  b.created_at

                ).getTime();

              return bDate - aDate;

            }

          );

          // Trigger change detection

          this.historyRecord = [

            ...this.historyRecord

          ];

          this.alert.showAlertMessage({

            message: isPinned

              ? 'Conversation pinned successfully.'

              : 'Conversation unpinned successfully.'

          });

        },

        error: (err: any) => {

          console.error(

            'Pin conversation failed',

            err

          );

          this.httpLoader.hideLoader();

          this.alert.showAlertMessage({

            message:

              'Failed to update pin status.'

          });

        }

      });

  }

  unpinItem(item: any): void {

    this.updatePinStatus(

      item,

      false

    );

  }

  private updatePinStatus(

    item: any,

    isPinned: boolean

  ): void {

    // API call

  }

  async loadDocx(url: string): Promise<void> {

    const requestId = ++this.currentDocRequest;

    try {

      this.documentLoading = true;

      this.docContainer.nativeElement.innerHTML = '';

      const response = await fetch(url);

      if (!response.ok) {

        throw new Error('Failed to fetch DOCX');

      }

      const buffer =

        await response.arrayBuffer();

      // Ignore outdated requests

      if (

        requestId !==

        this.currentDocRequest

      ) {

        return;

      }

      await renderAsync(

        buffer,

        this.docContainer.nativeElement

      );

    }

    catch (error) {

      console.error(

        'DOCX render failed',

        error

      );

    }

    finally {

      if (

        requestId ===

        this.currentDocRequest

      ) {

        this.documentLoading = false;

      }

    }

  }

  // changeDocument(doc: any): void {
  //   this.viewDocument(doc);
  // }

  viewDocument(doc: any): void {

    if (!doc) return;

    // Store current selected index
    this.selectedDocumentIndex = this.electedDocuments.findIndex(
      x => x.view_url === doc.view_url
    );

    this.documentLoading = true;

    this.isSelectFileType = doc.file_type;

    this.docViewHeading = doc.message ?? '';
    this.selectedReadFile = doc.view_url ?? '';

    this.fileType = (doc.file_type ?? '')
      .toLowerCase()
      .replace('.', '');

    if (!this.showDocumentPopup) {
      this.showDocumentPopup = true;
    }

    switch (this.fileType) {

      case 'pdf':
        break;

      case 'doc':
      case 'docx':
        setTimeout(() => {
          this.loadDocx(this.selectedReadFile);
        });
        break;

      case 'xls':
      case 'xlsx':
        // this.loadExcel(this.selectedReadFile);
        break;

      case 'ppt':
      case 'pptx':
        // this.loadPpt(this.selectedReadFile);
        break;

      default:
        this.documentLoading = false;
        console.warn(`Unsupported file type: ${this.fileType}`);
    }

  }

  // Called when document is completely loaded
  contentLoaded() { this.documentLoading = false; }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {

    if (!this.showDocumentDropdown) {
      return;
    }

    const clickedInside = this.dropdownWrapper
      ?.nativeElement
      ?.contains(event.target);

    if (!clickedInside) {
      this.showDocumentDropdown = false;
    }

  }

  startAIVoiceAgent() {

    const getState: any = this.stateCode === '' ? 'ALL' : this.stateCode;

    this.router.navigate(['/aiagent'], {
      queryParams: {
        state: getState
      }
    });

    // this.showPopup = !this.showPopup;

    // this.disconnect();

    // if (!this.showPopup) {

    //   this.isFullScreen = false;

    // }

  }


  setStatus(text: string, cls = '') {

    this.status = text;

    this.statusClass = cls;

  }


  async connect(): Promise<void> {

    if (this.connected || this.connecting) {
      return;
    }

    this.connecting = true;
    this.setStatus('Connecting...', 'connecting');

    try {

      const { token, url, roomName } = await this.fetchToken();

      this.room = new Room;

      // ===============================
      // Connected
      // ===============================
      this.room.on(RoomEvent.Connected, () => {

        this.connected = true;
        this.connecting = false;

        this.setStatus('Connected', 'connected');

        // if (this.showAvatar) {

        //   this.avatarListening = true;
        //   this.avatarSpeaking = false;

        //   this.pauseAvatarVideo();

        // }

        this.avatarListening = true;
        this.avatarSpeaking = false;

        this.isFullScreen = true;

      });

      // ===============================
      // Disconnected
      // ===============================
      this.room.on(RoomEvent.Disconnected, () => {

        this.connected = false;
        this.connecting = false;
        this.muted = false;

        this.avatarListening = false;
        this.avatarSpeaking = false;

        // this.pauseAvatarVideo();

        this.setStatus('Disconnected');

      });

      // ===============================
      // Remote Audio
      // ===============================
      this.room.on(RoomEvent.TrackSubscribed, (track: any) => {

        if (track.kind !== 'audio') {
          return;
        }

        const audio = track.attach();

        audio.autoplay = true;

        document.body.appendChild(audio);

        this.remoteAudioElement = audio;

      });

      // ===============================
      // Live Transcription
      // ===============================
      this.room.on(
        RoomEvent.TranscriptionReceived,
        (segments: any[], participant: any) => {

          const isAgent =
            participant &&
            participant !== this.room.localParticipant;

          // Avatar State
          if (this.showAvatar) {

            if (isAgent) {

              this.avatarSpeaking = true;
              this.avatarListening = false;

              // this.playAvatarVideo();

            } else {

              this.avatarListening = true;
              this.avatarSpeaking = false;

              // this.pauseAvatarVideo();

            }

          }

          segments.forEach((segment: any) => {

            const obj = {

              id: segment.id,
              text: segment.text,
              final: segment.final,
              isAgent

            };

            const index =
              this.transcriptList.findIndex(
                x => x.id === segment.id
              );

            if (index > -1) {

              this.transcriptList[index] = obj;

            } else {

              this.transcriptList.push(obj);

            }

            // Final Segment
            if (segment.final && this.showAvatar) {

              if (isAgent) {

                this.avatarSpeaking = false;

                // this.pauseAvatarVideo();

              } else {

                this.avatarListening = false;

              }

            }

          });

          this.transcriptScrollBottom();

        });

      // ===============================
      // Chat Messages
      // ===============================
      this.room.on(
        RoomEvent.DataReceived,
        (payload: Uint8Array, participant: any) => {

          if (participant === this.room.localParticipant) {
            return;
          }

          const decoder = new TextDecoder();

          const data = JSON.parse(
            decoder.decode(payload)
          );

          this.transcriptList.push({

            id: Date.now(),

            text: data.text,

            final: true,

            isAgent: true

          });

          this.transcriptScrollBottom();

        });

      // ===============================
      // Connect Room
      // ===============================
      await this.room.connect(url, token);

      // Create microphone only once
      this.localAudioTrack = await createLocalAudioTrack({
        echoCancellation: true,
        noiseSuppression: true,
        autoGainControl: true,

        // Optional constraints
        channelCount: 1,
        sampleRate: 48000
      });

      // Publish track
      await this.room.localParticipant.publishTrack(
        this.localAudioTrack
      );

    }

    catch (error) {

      console.error(error);

      this.setStatus('Connection Error');

    }

    finally {

      this.connecting = false;

    }

  }

  async fetchToken() {

    try {

      const payload = {
        cutomer_name: 'visitor'
      }

      const res: any = await firstValueFrom(
        this.botService.aiAgentVoiceConnect(payload)
      );


      return res;
    } catch (error) {
      console.log(error);

    }

  }


  async sendMessage() {

    const message =
      this.userMessage.trim();

    if (
      !message ||
      !this.room ||
      !this.connected
    ) {

      return;

    }

    // Add user message

    this.transcriptList.push({

      id: Date.now(),

      text: message,

      final: true,

      isAgent: false

    });

    try {

      const encoder =
        new TextEncoder();

      await this.room
        .localParticipant
        .publishData(

          encoder.encode(

            JSON.stringify({

              type: 'chat',

              text: message

            })

          ),

          {

            reliable: true

          }

        );

      this.userMessage = '';

      this.transcriptScrollBottom();
    }

    catch (err) {

      console.error(
        'Failed to send message',
        err
      );

    }

  }

  async sendToAgent(message: string): Promise<void> {

    if (!this.room || !this.connected) {
      return;
    }

    try {

      const encoder = new TextEncoder();

      await this.room.localParticipant.publishData(

        encoder.encode(
          JSON.stringify({
            type: 'message',
            text: message
          })
        ),

        {
          reliable: true
        }

      );

    }

    catch (err) {

      console.error(
        'Failed to send message',
        err
      );

    }

  }

  async disconnect(): Promise<void> {

    if (this.localAudioTrack) {
      this.localAudioTrack.stop();
      this.localAudioTrack = undefined;
    }

    if (this.remoteAudioElement) {
      this.remoteAudioElement.remove();
      this.remoteAudioElement = undefined;
    }

    if (this.room) {
      await this.room.disconnect();
    }

    this.connected = false;
    this.connecting = false;
    this.muted = false;
    this.showAvatar = false;
  }

  async toggleSession() {

    if (this.connected) {

      await this.disconnect();

    }

    else {

      await this.connect();

    }

  }

  async toggleMute(): Promise<void> {

    if (!this.localAudioTrack) {
      return;
    }

    this.muted = !this.muted;

    if (this.muted) {
      await this.localAudioTrack.mute();
    } else {
      await this.localAudioTrack.unmute();
    }
  }

  toggleFullscreen(): void {
    this.isFullScreen = !this.isFullScreen;
  }



  toggleVideoMute(): void {

    this.showAvatar = !this.showAvatar;

    this.showAvatar = this.avatarMode;

    // if (!this.avatarMode) {

    //   // this.avatarDocked = false;
    //   this.avatarListening = false;
    //   this.avatarSpeaking = false;

    // }

    this.avatarListening = false;
    this.avatarSpeaking = false;

  }

  private transcriptScrollFrame: number | null = null;

  /**
   * Initial page/history load
   * Jump immediately to the bottom.
   */
  private transcriptScrollBottomInstant(): void {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const container = this.transcriptContainer?.nativeElement;

        if (!container) {
          return;
        }

        container.scrollTop = container.scrollHeight;
      });
    });
  }

  /**
   * Streaming/new message scroll
   * Prevents jumping while tokens are rendering.
   */
  private transcriptScrollBottom(): void {
    if (this.transcriptScrollFrame !== null) {
      return;
    }

    this.transcriptScrollFrame = requestAnimationFrame(() => {
      this.transcriptScrollFrame = null;

      const container = this.transcriptContainer?.nativeElement;

      if (!container) {
        return;
      }

      container.scrollTop = container.scrollHeight;
    });
  }

  private scrollHistoryToBottom(): void {
    if (this.historyScrollFrame !== null) {
      cancelAnimationFrame(this.historyScrollFrame);
    }

    this.historyScrollFrame = requestAnimationFrame(() => {
      this.historyScrollFrame = null;

      requestAnimationFrame(() => {
        const container = this.chatContainer?.nativeElement;

        if (!container) {
          return;
        }

        const targetScrollTop =
          container.scrollHeight - container.clientHeight;

        if (targetScrollTop <= 0) {
          return;
        }

        container.scrollTo({
          top: targetScrollTop,
          behavior: 'smooth'
        });

        this.isAtBottom = true;
      });
    });
  }

  playAvatarVideo(): void {

    if (!this.avatarPlayer?.nativeElement) {
      return;
    }

    const video = this.avatarPlayer.nativeElement;

    video.muted = true;
    video.loop = true;

    if (video.paused) {

      video.currentTime = 0;

      video.play().catch(() => { });

    }

  }

  pauseAvatarVideo(): void {

    if (!this.avatarPlayer?.nativeElement) {
      return;
    }

    const video = this.avatarPlayer.nativeElement;

    video.pause();

    video.currentTime = 0;

  }



  onInput(event: Event) {
    this.queryInputValue =
      (event.target as HTMLDivElement).innerText;


  }

  onEditorKeyDown(event: KeyboardEvent) {

    // Shift + Enter => New line
    if (event.key === 'Enter' && event.shiftKey) {
      return;
    }

    // Enter => Send
    if (event.key === 'Enter') {
      event.preventDefault();

      this.queryInputValue = this.messageInput.nativeElement.innerText.trim();

      if (!this.queryInputValue) return;

      this.submitQuestion();

      this.messageInput.nativeElement.innerHTML = '';
      this.queryInputValue = '';
    }
  }


  deleteHistory(item: any, event: Event): void {

    event.stopPropagation();

    if (!item?.conversation_id) {
      return;
    }

    this.confirmDialogService.openConfirmDialog('', {

      title: 'Confirmation',

      message: 'Are you sure you want to delete this conversation?',

      btnOkText: 'Delete',

      btnCancelText: 'Cancel',

      onClose: (confirmed: boolean) => {

        if (!confirmed) {
          return;
        }

        this.httpLoader.showLoader();

        this.botService
          .deleteConversationData(item.conversation_id)
          .subscribe({

            next: (res: any) => {

              if (!res?.success) {
                return;
              }

              // Remove from history list
              this.historyRecord = this.historyRecord.filter(
                (history: any) =>
                  history.conversation_id !== item.conversation_id
              );

              // If current conversation is deleted
              if (
                this.selectedItem?.conversation_id ===
                item.conversation_id
              ) {

                this.selectedItem = null;
                this.chatData = [];
                this.activeHistoryId = null;

                // Load next available conversation
                if (this.historyRecord.length) {
                  this.onSelectConversation(
                    this.historyRecord[0]
                  );
                }

              }

              this.alert.showAlertMessage({

                message:
                  'Conversation deleted successfully.'

              });

            },

            error: (err: any) => {

              console.error(
                'Delete conversation failed',
                err
              );

              this.alert.showAlertMessage({

                message:
                  err?.error?.message ??
                  'Failed to delete conversation.'

              });

            },

            complete: () => {

              this.httpLoader.hideLoader();

            }

          });

      }

    });

  }



  toggleDropdownDoc(): void {
    this.showDocDropdown = !this.showDocDropdown;
  }

  selectDocument(doc: any): void {
    console.log('Selected Document:', doc);

    // Open/Preview/Download logic
    // window.open(doc.url);

    this.showDocDropdown = false;
  }


  changeDocument(index: number): void {

    if (index < 0 || index >= this.electedDocuments.length) {
      return;
    }

    this.selectedDocumentIndex = index;

    this.viewDocument(this.electedDocuments[index]);

  }

  previousDocument(): void {

    if (this.selectedDocumentIndex > 0) {
      this.changeDocument(this.selectedDocumentIndex - 1);
    }

  }

  nextDocument(): void {

    if (this.selectedDocumentIndex < this.electedDocuments.length - 1) {
      this.changeDocument(this.selectedDocumentIndex + 1);
    }

  }

  getVideoPlayingOnTime(event: any) {
    var curTimeTrack = 0;

    setTimeout(() => {
      const timeInMiliseconds = event;

      var sec_num = parseInt(timeInMiliseconds, 10);
      var hours = Math.floor(sec_num / 3600);
      var minutes = Math.floor((sec_num - hours * 3600) / 60);
      var seconds = sec_num - hours * 3600 - minutes * 60;

      var x = hours < 10 ? "0" + hours : hours;
      var y = minutes < 10 ? "0" + minutes : minutes;
      var z = seconds < 10 ? "0" + seconds : seconds;

      var getHours = x + ":" + y + ":" + z;


      var a = getHours.split(":");

      var getSeconds = +a[0] * 60 * 60 + +a[1] * 60 + +a[2];

      var getAtSeconds = getSeconds;

      console.log(getAtSeconds);


      // const timeQuiz = this.interactiveVideoQuiz.map((el) => {
      //   return el;
      // });

      // const timeArray = this.interactiveVideoQuiz.map((e) => {
      //   return e.quiz_time;
      // });

      // timeQuiz.some((x) => {
      //   if (getAtSeconds === parseInt(x.quiz_time)) {
      //     this.media.nativeElement.pause();
      //     this.videoQuizId = x.quiz_id;
      //     this.getVideoQuizz = x.questions;
      //     this.pager.count = this.getVideoQuizz.length;
      //     this.activeQuiz = "block";
      //     this.videoQuizRequired = x.is_required;
      //   }
      // });
    }, 800);
  }

  ngOnDestroy() {
    if (this.headingSubscription) {
      this.headingSubscription.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }
}
